import { connect, initializable } from "effects";
import * as functions from "./functions";
import Home from "./Home";

const mapStateToProps = (state, ownProps, prop) => {
  return {};
};

export default connect(initializable(Home), mapStateToProps, functions);
